import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsRepresentanteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/representante');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic Regra');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/representante', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic Regra');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/representante', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pic Regra');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/representante/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic Regra');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/representante/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic Regra');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/representante/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Pic Regra');
    }
  }

  async listarRepresentanteInfoPedido(queries = {}) {
    try {
      // Ensure default pagination parameters
      const queryParams = {
        page: 1,
        perPage: 10,
        ...queries,
      };

      const response = await this.api.get('/representante/listarRepresentanteInfoPedido', {
        params: queryParams,
      });

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async listarRepresentanteByClienteIdERP(clienteiderp) {
    try {
      const response = await this.api.get(`/representante/listarRepresentanteByClienteIdERP/${clienteiderp}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
